import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Router } from "@angular/router";
import {
  fetchLanguages,
  fetchLanguagesSuccess,
  fetchLanguagesFailure
} from "./language.actions";
import { EMPTY, of } from "rxjs";
import { map, mergeMap, catchError, tap } from "rxjs/operators";
import { LanguageService } from '../../services/language/language.service';


@Injectable()
export class LanguageEffects {

loadLanguages$ = createEffect(() =>
this.actions$.pipe(
  ofType(fetchLanguages),
  mergeMap(action =>
    this.languageService.getLanguages(action.filterOptions).pipe(
      map(res => {
        return fetchLanguagesSuccess({ languages: res });
      }),
      catchError(error => {
        return of(fetchLanguagesFailure({ error }));
      })
    )
  )
)
);

constructor(
  private actions$: Actions,
  private languageService: LanguageService
) {}
}
